/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum DetectionSource {
  ROBOFLOW = "ROBOFLOW",
  ULTRALYTICS = "ULTRALYTICS",
  MAPILLARY = "MAPILLARY",
  MULTI_MODEL = "MULTI_MODEL",
  NONE = "NONE",
}
